// extracted by mini-css-extract-plugin
module.exports = {"lia-modal-title":"PagerSeeAllModal_lia-modal-title__m4LIv"};